import { render, staticRenderFns } from "./chooseTemplate.vue?vue&type=template&id=0b9789c9&scoped=true"
import script from "./chooseTemplate.vue?vue&type=script&lang=js"
export * from "./chooseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9789c9",
  null
  
)

export default component.exports